import { reactive } from "@vue/composition-api";

export default function useFlatPickr() {
  const validFrom = reactive({ date: null, time: null });
  const validThrough = reactive({ date: null, time: null });

  const flatpickrDateConfig = reactive({
    allowInput: true,
    altFormat: "F j, Y",
    dateFormat: "d-m-Y",
    maxDate: null,
    minDate: null,
    monthSelectorType: "static",
    disableMobile: true,
    onReady(selectedDate, dateStr, instance) {
      const el = instance.element;
      const preventInput = (event) => {
        event.preventDefault();
        return false;
      };
      el.onkeypress = preventInput;
      el.onkeydown = preventInput;
      el.onkeyup = preventInput;
      el.onpaste = preventInput;
      el.onfocusout = preventInput;
      el.onfocus = preventInput;
      el.style.caretColor = "transparent";
      el.style.cursor = "pointer";
    },
  });

  const fixedNum = (number, pad) => number.toString().padStart(pad, "0");

  const flatpickrTimeConfig = reactive({
    allowInput: true,
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
    maxTime: null,
    minTime: null,
    minuteIncrement: 1,
    disableMobile: true,
    onReady(selectedDate, dateStr, instance) {
      const el = instance.element;
      const preventInput = (event) => {
        event.preventDefault();
        return false;
      };
      el.onkeypress = preventInput;
      el.onkeydown = preventInput;
      el.onkeyup = preventInput;
      el.onpaste = preventInput;
      el.onfocusout = preventInput;
      el.onfocus = preventInput;
      el.style.caretColor = "transparent";
      el.style.cursor = "pointer";
    },
  });

  const resolveDateString = (dateString) => {
    const date = dateString.split("-");

    const resolvedDate = `${date[2]}-${date[1]}-${date[0]}`;

    return resolvedDate;
  };

  const resolveDateObject = (dateObject) => {
    if (!dateObject) return null;
    if (!dateObject.date && !dateObject.time) return null;

    const date = dateObject.date.split("-");
    const time = dateObject.time.split(":");

    const resolvedDate = `${date[2]}-${date[1]}-${date[0]} ${time[0]}:${time[1]}:00`;
    return resolvedDate;
  };

  const resolveDate = (dateInput) => {
    const date = new Date(dateInput);

    try {
      const dateStr = `${date.toLocaleString("default", {
        day: "2-digit",
      })}-${date.toLocaleString("default", {
        month: "2-digit",
      })}-${date.getFullYear()}`;
      return dateStr;
    } catch (err) {
      return "";
    }
  };

  const resolveTime = (timeInput) => {
    const time = new Date(timeInput);

    try {
      const hours = time.getHours();
      const minutes = time.getMinutes();

      const timeStr = `${fixedNum(hours, 2)}:${fixedNum(minutes, 2)}`;

      return timeStr;
    } catch (err) {
      return "";
    }
  };

  const resolveReverseDate = (date) => {
    const splitDate = date.split("-");

    const reverseDate = splitDate.reverse();

    return reverseDate.join("-");
  };

  const resolveFullTime = (timeInput) => {
    const time = new Date(timeInput);

    try {
      const hours = time.getHours();
      const minutes = time.getMinutes();
      const seconds = time.getSeconds();

      const timeStr = `${fixedNum(hours, 2)}:${fixedNum(minutes, 2)}:${fixedNum(
        seconds,
        2
      )}`;

      return timeStr;
    } catch (err) {
      return "";
    }
  };

  const onOpenValidFromDatePicker = () => {
    flatpickrDateConfig.minDate = null;
  };

  const onSelectValidFromDate = () => {
    if (validThrough.date) {
      const validThroughDate = new Date(resolveDateString(validThrough.date));
      const validFromDate = new Date(resolveDateString(validFrom.date));

      if (validFromDate > validThroughDate) {
        validFrom.date = null;
        validThrough.date = null;
      }
    }
    flatpickrDateConfig.minDate = validFrom.date;
  };

  const onOpenValidFromTimePicker = () => {
    flatpickrTimeConfig.minTime = null;
  };

  const onOpenValidThroughTimePicker = () => {
    if (validFrom.date == validThrough.date) {
      flatpickrTimeConfig.minTime = validFrom.time;
    }
  };

  const onSelectValidFromTimePicker = () => {
    if (
      validFrom.date == validThrough.date &&
      validFrom.time > validThrough.time
    ) {
      validThrough.time = null;
    }
  };

  return {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateString,
    resolveDateObject,
    resolveDate,
    resolveTime,
    resolveFullTime,
    resolveReverseDate,
  };
}
